import { AxiosResponse } from "axios";
import { api } from "../base/api";
import { KeyValue, KeyValueDefault } from "../../models/common";
import { InsurerFilterRequest, InsurerSaveRequest } from "../../models/request";
import {
	IGetByInsurer,
	InsurerAgreementsResponse,
	InsurerRegistrationDataResponse,
	InsurerResponse,
	InsurerSaveRespose,
} from "../../models/response";
import { IInsurerApi } from "../base/registration/insurerApi";
import { Result } from "../../models/common/resultResponse";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

const baseRoute: string = "Insurer";

export class InsurerApi extends IInsurerApi {
	getInsurersOrInsurerBranchesDomain(request: InsurerFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getInsurers(request: InsurerFilterRequest): Promise<AxiosResponse<InsurerResponse>> {
		return api.get(`${baseRoute}`, { params: request });
	}

	getInsurersFullDomain(request: InsurerFilterRequest): Promise<AxiosResponse<InsurerResponse>> {
		return api.get(`${baseRoute}/getFullDomain`, { params: request });
	}

	getInsurersBodyshopAgreements(
		request: InsurerFilterRequest,
	): Promise<AxiosResponse<Result<InsurerAgreementsResponse[]>>> {
		return api.get(`${baseRoute}/bodyshopagreements`, { params: request });
	}

	getRegistrationDataInsurer(
		request: InsurerFilterRequest,
	): Promise<AxiosResponse<Result<InsurerRegistrationDataResponse>>> {
		return api.get(`${baseRoute}/getinsurerdata`, {
			params: request,
		});
	}

	saveInsurer(request: InsurerSaveRequest): Promise<AxiosResponse<Result<InsurerSaveRespose>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	getInsurersPublic(guidCountry: string): Promise<AxiosResponse<KeyValueDefault[]>> {
		return api.get(`${baseRoute}/insurerdomain_public`, {
			params: { guidCountry },
		});
	}

	getByInsurer(request: InsurerFilterRequest): Promise<AxiosResponse<PaginationResponse<IGetByInsurer>>> {
		return api.get(`${baseRoute}/getbyinsurer`, {
			params: request,
		});
	}

	getUsersByInsurer(request: InsurerFilterRequest): Promise<KeyValue[]> {
		return api.get(`${baseRoute}/domain/getusersbyinsurer`, {
			params: request,
		});
	}
}
